import { SCALE_DASHBOARD_FRONTEND_URL } from '@scale/frontend-lib/constants';

export const NULL_PROJECT_ID = '-';
export const DEFAULT_ERROR_MESSAGE = 'An internal server error occurred, please try again later.';
export const dashboardURL = SCALE_DASHBOARD_FRONTEND_URL + '/';

function getLoginPath() {
  try {
    return new URLSearchParams(location.search).has('spoof') ? '/corp/login' : '/login';
  } catch {
    // HACK: To get this running in Next.js context (no location global)
    return '/login';
  }
}

export const LOGIN_PATH = getLoginPath();
export const PYTHON_SDK_DOCS_URL = 'https://docs.nucleus.scale.com/';
export const DOCUMENTATION_URL = 'https://nucleus.scale.com/docs/';
export const CREATE_DATASET_GUIDE_URL = DOCUMENTATION_URL + 'uploading-images#creating-a-dataset';
export const UPLOAD_TO_DATASET_GUIDE_URL =
  DOCUMENTATION_URL + 'datasets-in-nucleus#uploading-your-data';
export const ADD_DATASETITEMS_GUIDE_URL =
  DOCUMENTATION_URL + 'uploading-images#creating-image-datasetitems';
export const ADD_VIDEO_SCENES_GUIDE_URL = DOCUMENTATION_URL + 'uploading-videos';
export const ADD_TRACKS_GUIDE_URL = DOCUMENTATION_URL + 'grouping-annotations-via-tracks';
export const ADD_LIDAR_SCENES_GUIDE_URL = DOCUMENTATION_URL + 'uploading-3d-data';
export const UPLOAD_ANNOTATIONS_GUIDE_URL = DOCUMENTATION_URL + 'uploading-annotations';
export const COCO_ANNOTATIONS_GUIDE_URL =
  DOCUMENTATION_URL + 'uploading-annotations-from-ui#coco-object-detection';
export const PASCAL_ANNOTATIONS_GUIDE_URL =
  DOCUMENTATION_URL + 'uploading-annotations-from-ui#pascal-annotation-version-100';
export const ADD_ANNOTATIONS_GUIDE_URL = DOCUMENTATION_URL + 'ground-truth-annotations-in-nucleus';
export const ADD_PREDICTIONS_GUIDE_URL = DOCUMENTATION_URL + 'model-predictions-in-nucleus';
export const CALCULATE_METRICS_GUIDE_URL = DOCUMENTATION_URL + 'calculate-evaluation-metrics';
export const ASYNC_JOBS_GUIDE_URL = DOCUMENTATION_URL + 'async-jobs';
export const QUERY_BAR_GUIDE_URL = DOCUMENTATION_URL + 'query-language-reference';
export const QUERY_BAR_GUIDE_NL_URL = DOCUMENTATION_URL + 'natural-language-search';
export const CREATE_EXTERNAL_EVAL_GUIDE_URL = DOCUMENTATION_URL + 'external-evaluation-functions';

export const LICENSE_URL = 'https://scale.com/legal/nucleus-os';
export const PENNFUDAN_URL = 'https://www.cis.upenn.edu/~jshi/ped_html/PennFudanPed.zip';
